module.exports = __webpack_public_path__ + "static/media/london.3000540b.jpg";